import { useOrganizationLinks } from "@/queries/use-organization-links.query.ts";
import {
  Button,
  FontAwesomeIcon,
  ListItem,
  Modal,
  ModalProps,
  Skeleton,
  Stack,
  Text,
} from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useEffectOnce } from "react-use";
import analyticsService, { analyticEvents } from "@/services/analytics-service.ts";

export function OrganizationLinksModal(props: ModalProps) {
  const { t } = useTranslation();
  const { data: links, isLoading } = useOrganizationLinks();

  useEffectOnce(() => {
    analyticsService.trackEvent(analyticEvents.organizationLinks.viewed);
  });

  return (
    <Modal {...props} size={"lg"} title={t("core:organization_links")} withCloser>
      {isLoading ? (
        <Stack gap={"md"}>
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton key={index} className="h-15 w-full" />
          ))}
        </Stack>
      ) : links?.length === 0 ? (
        <Text className={"text-secondary"}>{t("common:no_records_yet")}</Text>
      ) : (
        <Stack gap={"2xl"} className={"mt-5"}>
          {links?.map((link) => (
            <ListItem
              key={`link-${link.id}`}
              title={link.title}
              behavior="card"
              valueSlot={
                <Button
                  variant={"plain"}
                  rightIcon={<FontAwesomeIcon icon={"fa-light fa-chevron-right"} />}
                  onClick={() => window.open(link.url, "_blank")}
                >
                  <Text className={"text-title text-sm"}> {t("common:open")}</Text>
                </Button>
              }
            />
          ))}
        </Stack>
      )}
    </Modal>
  );
}
